import CartOrderService from "../../Services/CartOrderService";

export const FETCH_CART_REQUEST = "FETCH_CART_REQUEST";
export const FETCH_CART_SUCCESS = "FETCH_CART_SUCCESS";
export const FETCH_CART_FAILURE = "FETCH_CART_FAILURE";

export const ADD_CART_REQUEST = "ADD_CART_REQUEST";
export const ADD_CART_SUCCESS = "ADD_CART_SUCCESS";
export const ADD_CART_FAILURE = "ADD_CART_FAILURE";

export const getCartDetails = (payload) => async (dispatch) => {
    dispatch({ type: FETCH_CART_REQUEST });
    try {
        const response = await CartOrderService.getOrderList(payload);
        dispatch({ type: FETCH_CART_SUCCESS, payload: !response.data.data? null: response.data.data[0] });
    } catch (error) {
        dispatch({ type: FETCH_CART_FAILURE, payload: error.message });
    }
};

export const AddtoCart = (payload) => async (dispatch) => {
    dispatch({ type: ADD_CART_REQUEST });

    try {
        const response = await CartOrderService.AddToCart(payload);
        dispatch({ type: ADD_CART_SUCCESS, payload: response.data });
        return Promise.resolve(response.data);
    } catch (error) {
        dispatch({ type: ADD_CART_FAILURE, payload: error.message });
        // return Promise.reject(error);
        throw error;
    }
};

export const ForeignAddtoCart = (payload) => async (dispatch) => {
    dispatch({ type: ADD_CART_REQUEST });

    try {
        const response = await CartOrderService.foreignAddToCart(payload);
        dispatch({ type: ADD_CART_SUCCESS, payload: response.data });
        return Promise.resolve(response.data);
    } catch (error) {
        dispatch({ type: ADD_CART_FAILURE, payload: error.message });
        // return Promise.reject(error);
        throw error;
    }
};

export const updateCartState = (data) => ({
  type: FETCH_CART_SUCCESS,
  payload: data,
});

